import { render, staticRenderFns } from "./GameRegulations.vue?vue&type=template&id=50483450&lang=pug&"
import script from "./GameRegulations.vue?vue&type=script&lang=js&"
export * from "./GameRegulations.vue?vue&type=script&lang=js&"
import style0 from "./GameRegulations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports